import type { CreateUpdateDropDownDTO, DropDownConfigDTO } from './drop-down-config/models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedAndSortedResultRequestDto, PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DropDownConfigService {
  apiName = 'Default';
  

  create = (input: CreateUpdateDropDownDTO, config?: Partial<Rest.Config>) =>
    this.restService.request<any, DropDownConfigDTO>({
      method: 'POST',
      url: '/api/app/drop-down-config',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/drop-down-config/${id}`,
    },
    { apiName: this.apiName,...config });
  

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, DropDownConfigDTO>({
      method: 'GET',
      url: `/api/app/drop-down-config/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getList = (input: PagedAndSortedResultRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<DropDownConfigDTO>>({
      method: 'GET',
      url: '/api/app/drop-down-config',
      params: { sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  update = (id: string, input: CreateUpdateDropDownDTO, config?: Partial<Rest.Config>) =>
    this.restService.request<any, DropDownConfigDTO>({
      method: 'PUT',
      url: `/api/app/drop-down-config/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
